import type {
  ILink,
  INewLink,
  INewUserEntry,
  IUpdatableLinkChain,
} from "~/models/IUserEntry";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

export function useLinkChain() {
  const linkSaving = ref(false);
  const { t } = useI18n();
  const toast = useToast();
  const { updateEntry, saveEntry } = useEntries();

  const saveLinkChain = async (
    legaltextParagraph: ILegalTextParagraph,
    payload: IUpdatableLinkChain | (INewUserEntry & { links: INewLink[] })
  ) => {
    linkSaving.value = true;
    try {
      if ("id" in payload) {
        await updateEntry({
          ...payload,
          legal_text_paragraph_id: legaltextParagraph.id,
          // technically not correct - updateEntry expects the write and read types to be the same which they aren't for link_chains
          links: payload.links as ILink[],
        });
      } else {
        await saveEntry(legaltextParagraph, {
          ...payload,
          type: "link_chain",
        });
      }
    } catch (_e) {
      toast.error(
        t("legal_text.textEditor.errors.link_chain_could_not_be_saved")
      );
    }
    linkSaving.value = false;
  };

  return {
    linkSaving,
    saveLinkChain,
  };
}
